import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Alert } from "../../Alert/Alert";

//Custom Component
import PASDetailForm from "./PASDetailForm";
import PASEditForm from "./PASEditForm";
import PasMaster from "./pasSection/pasMaster";
import PasPrintConfig from "./pasSection/pasPrintConfig";
import NormalDialog from "../../Dialog/NormalDialog";

import { getPasDetails } from "../../../dataSource/pas";
// Custom Style
import { pasStyle } from "../../../styles/jss/components/PAS/pasStyle";
const useStyles = makeStyles((theme) => pasStyle(theme));
const PAS = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [editable, setEditable] = useState(false);
  const [pasDetails, setPasDetails] = useState(false);
  const [saleEditorValue, setSaleEditorValue] = useState("");
  const [progressEditorValue, setProgressEditorValue] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [printFlag, setPrintFlag] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertData, setAlertData] = useState({
    type: "",
    title: "",
    content: "",
  });

  const getPas = async () => {
    const response = await getPasDetails();
    setPasDetails(response.data);
    setSaleEditorValue(response.data.details.sale_preparation);
    setProgressEditorValue(response.data.details.prog_qual_cost);
  };

  // Build Alert
  const buildAlert = (data) => {
    setAlertData({
      type: data.type,
      title: data.title,
      content: data.content,
    });
    setAlertOpen(true);
  };

  useEffect(() => {
    const getPasFormData = async () => {
      await getPas();
    };
    getPasFormData();
  }, []);

  return (
    <Fragment>
      <NormalDialog
        open={openDialog}
        dialogTitle={"Print"}
        formContent={
          <PasPrintConfig
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            pasDetails={pasDetails}
            printFlag={printFlag}
            setPrintFlag={setPrintFlag}
          />
        }
        button={[]}
        handleClose={() => {
          setOpenDialog(false);
        }}
        size={"lg"}
        height={700}
      />
      <Alert
        open={alertOpen}
        alertType={alertData.type}
        alertTitle={alertData.title}
        alertContent={alertData.content}
        handleClose={() => setAlertOpen(false)}
      />
      <PasMaster
        editable={editable}
        setEditable={setEditable}
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
      />
      <Grid>
        {editable ? (
          <PASEditForm
            pasDetails={pasDetails}
            setPasDetails={setPasDetails}
            saleEditorValue={saleEditorValue}
            setSaleEditorValue={setSaleEditorValue}
            progressEditorValue={progressEditorValue}
            setProgressEditorValue={setProgressEditorValue}
            setEditable={setEditable}
            buildAlert={buildAlert}
          />
        ) : (
          <PASDetailForm
            editable={editable}
            pasDetails={pasDetails}
            saleEditorValue={saleEditorValue}
            progressEditorValue={progressEditorValue}
          />
        )}
      </Grid>
    </Fragment>
  );
};

export default PAS;
